import { render, staticRenderFns } from "./modalImportGroupMembers.vue?vue&type=template&id=2287034a&"
import script from "./modalImportGroupMembers.vue?vue&type=script&lang=js&"
export * from "./modalImportGroupMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports